import { languages as languagesConstants } from '@/common/constants'

export const getLanguageLabels = t => {
  return Object.fromEntries(languagesConstants(t).map(language => [language.value, language.label]))
}

export const getCurrentAvailableLanguage = (languages, selectedLanguage) => {
  const currentLanguage = languages?.find(lang => lang === selectedLanguage)

  return currentLanguage || languages?.[0]
}

export const getLanguagesWithDefaultFirst = (languages, defaultLanguage) => {
  if (!languages.includes(defaultLanguage)) return languages

  return [defaultLanguage, ...languages.filter(language => language !== defaultLanguage)]
}

export const getActiveLanguage = (languages, errorLanguages) => {
  const languageWithError = languages.find(language => errorLanguages.includes(language))

  return languageWithError || languages[0]
}

export const createRegionObjet = regions => {
  const regionObjet = {}
  regions?.forEach(region => {
    regionObjet[region.id] = region.id
    region.provinces?.forEach(province => {
      regionObjet[province.id] = region.id
    })
  })
  return regionObjet
}

export const isRegionIdInRegions = (regionId, allowedRegions, allRegions) => {
  const regionsObject = createRegionObjet(allRegions)
  const countryRegionId = regionsObject[regionId]

  if (!countryRegionId) {
    return false
  }

  for (const allowedRegionId of allowedRegions) {
    if (allowedRegionId === regionId) {
      return true
    }

    if (allowedRegionId === countryRegionId) {
      return true
    }
  }

  return false
}

export const getErrorCountKey = count => (count === 1 ? '{{count}} error' : '{{count}} errores')
